  // import './App.css';
  // import { Outlet, useLocation, useNavigate } from 'react-router-dom';
  // import { ToastContainer } from 'react-toastify';
  // import 'react-toastify/dist/ReactToastify.css';
  // import 'react-loading-skeleton/dist/skeleton.css';
  // import 'react-phone-input-2/lib/style.css';
  // import ScrollToTop from './helpers/ScrollToTop';
  // import useFetchLoginUser from './hooks/useFetchLoginUser';
  // import PageLoader from './helpers/PageLoader';
  // import { useEffect } from 'react';
  // import { setNavigationHandler } from './common/apiClient';
  // import { useSelector } from "react-redux";
  // import socket from './socket';
  // import GlobalReminderPopup from './pages/GlobalReminderPopup';
  // import notificationSound from "./assets/notification.mp3";
  // const App = () => {
  //   const navigate = useNavigate();
  //   const location = useLocation();
  //   const loading = useFetchLoginUser();
  //   const user = useSelector( state => state?.user?.user);
  //   useEffect(() => {

  //     const unlockAudio = async () => {

  //         try {

  //           const audio =
  //               new Audio(
  //                 notificationSound
  //               );

  //           audio.volume = 1;

  //           audio.preload = "auto";

  //           await audio.play();

  //           audio.pause();

  //           audio.currentTime = 0;

  //           window.notificationAudio =
  //               audio;

  //           // console.log(
  //           //     "Audio Ready"
  //           // );

  //         } catch (error) {

  //           console.log(
  //               "Unlock Error:",
  //               error
  //           );

  //         }

  //     };

  //     window.addEventListener(
  //         "click",
  //         unlockAudio,
  //         { once: true }
  //     );

  //   }, []);
  //   useEffect(() => {

  //     if(user?._id){

  //         socket.emit(
  //           "join",
  //           user._id
  //         );

  //         // console.log(
  //         //   "Socket Joined:",
  //         //   user._id
  //         // );

  //     }

  //   }, [user]);

  //   // Set up navigation handler for API client
  //   useEffect(() => {
  //     setNavigationHandler(navigate);
  //   }, [navigate]);

  //   // Clear localStorage & prevent back navigation on "/" or "/login"
  //       useEffect(() => {
  //         const currentPath = location.pathname;
  //         if (currentPath === '/' || currentPath === '/login' || currentPath === '/sign-up') {
  //           localStorage.clear();
            
  //           // Replace the current history entry to prevent back navigation
  //           window.history.replaceState(null, '', currentPath);
            
  //           // Clear the history stack by replacing the state
  //           navigate(currentPath, { replace: true });
            
  //           // Disable browser back button
  //           window.history.pushState(null, null, window.location.href);
  //           window.onpopstate = function () {
  //             window.history.go(1);
  //           };
  //         }
          
  //         // Cleanup function to remove the popstate listener
  //         return () => {
  //           window.onpopstate = null;
  //         };
  //       }, [location.pathname, navigate]);

  //   if (loading) {
  //     return (
  //       <div className="h-screen flex justify-center items-center">
  //         <PageLoader />
  //       </div>
  //     );
  //   }

  //   return (
  //     <>
  //       <ScrollToTop />
  //       <main className='min-h-[calc(100vh-120px)]'>
  //         <Outlet />
  //         <GlobalReminderPopup />
  //       </main>
  //       <ToastContainer position="top-center" autoClose={1500} />
  //     </>
  //   );
  // }

  // export default App;




import "./App.css";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-phone-input-2/lib/style.css";

import ScrollToTop from "./helpers/ScrollToTop";
import useFetchLoginUser from "./hooks/useFetchLoginUser";
import PageLoader from "./helpers/PageLoader";

import { useEffect,useRef } from "react";
import { setNavigationHandler } from "./common/apiClient";
import { useSelector } from "react-redux";

import socket from "./socket";
import GlobalReminderPopup from "./pages/GlobalReminderPopup";
import notificationSound from "./assets/notification.mp3";
import { isPublicPath } from "./common/publicRoutes";
 import { subscribeToPush } from "./services/SubscribeToPush";
const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isPublic = isPublicPath(location.pathname);

  const loading = useFetchLoginUser();
  const user = useSelector((state) => state?.user?.user);
   const pushInitialized = useRef(false);
    useEffect(() => {

  if (loading) return;

  if (!user?._id) return;

  if (pushInitialized.current) return;

  pushInitialized.current = true;

  subscribeToPush().catch((err) => {
    console.error("Push subscription failed:", err);
  });

}, [loading, user?._id]);

  useEffect(() => {
    const unlockAudio = async () => {
      try {
        const audio = new Audio(notificationSound);

        audio.volume = 1;
        audio.preload = "auto";

        await audio.play();

        audio.pause();
        audio.currentTime = 0;

        window.notificationAudio = audio;
      } catch (error) {
        console.log("Unlock Error:", error);
      }
    };

    window.addEventListener("click", unlockAudio, {
      once: true,
    });
  }, []);

  useEffect(() => {
    if (user?._id) {
      socket.emit("join", user._id);
    }
  }, [user]);

  // Navigation handler
  useEffect(() => {
    setNavigationHandler(navigate);
  }, [navigate]);

  // Clear local storage only for auth pages
  useEffect(() => {
    const currentPath = location.pathname;

    if (
      currentPath === "/" ||
      currentPath === "/login" ||
      currentPath === "/sign-up"
    ) {
      localStorage.clear();

      window.history.replaceState(null, "", currentPath);

      navigate(currentPath, {
        replace: true,
      });

      window.history.pushState(
        null,
        null,
        window.location.href
      );

      window.onpopstate = function () {
        window.history.go(1);
      };
    }

    return () => {
      window.onpopstate = null;
    };
  }, [location.pathname, navigate]);

  // Don't show loader for public routes
  if (!isPublic && loading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <PageLoader />
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />

      <main className="min-h-[calc(100vh-120px)]">
        <Outlet />
        <GlobalReminderPopup />
      </main>

      <ToastContainer
        position="top-center"
        autoClose={1500}
      />
    </>
  );
};

export default App;